import { render, staticRenderFns } from "./EventInformation.vue?vue&type=template&id=3a734183&scoped=true"
import script from "./EventInformation.vue?vue&type=script&lang=ts"
export * from "./EventInformation.vue?vue&type=script&lang=ts"
import style0 from "./EventInformation.vue?vue&type=style&index=0&id=3a734183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a734183",
  null
  
)

export default component.exports